import { render, staticRenderFns } from "./OrderDetails.vue?vue&type=template&id=7268d53d&scoped=true"
import script from "./OrderDetails.vue?vue&type=script&lang=ts"
export * from "./OrderDetails.vue?vue&type=script&lang=ts"
import style0 from "./OrderDetails.vue?vue&type=style&index=0&id=7268d53d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7268d53d",
  null
  
)

export default component.exports